import React from "react";
import { Row, Col, Tabs, Card, Button, Avatar } from "antd";
import PropTypes from "prop-types";
import PersonnelList from "routes/Home/Basic/Personnel/List/ListWrapper";
import Assignment from "../Assignment";
import Setting from "./Setting/Setting";
import { List } from "./List";
import { connect } from "react-redux";
import { showUser, emptyUser } from "./Module";
import SettingWrapper from "./Setting/SettingWrapper";
import Spin from "components/common/Spin";
import Sms from "./Sms/Sms";

@connect(
  (state) => ({
    user: state.Basic.Personnel.user,
  }),
  {
    show: showUser,
    empty: emptyUser,
  }
)
@authorize
@autobind
/**
 *
 */
export default class Personnel extends React.PureComponent {
  static propTypes = {
    personnel: PropTypes.object,
    can: PropTypes.func,
  };

  static defaultProps = {};

  /**
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props);

    this.state = {
      personnel: props.personnel ? [props.personnel] : [],
      loading: true,
    };
    if (this.personnelsRef) {
      this.personnelsRef.empty();
    }
  }

  /**
   *
   */
  componentWillUnmount() {
    super.componentWillUnmount();
  }

  /**
   *
   * @param {object} item
   * @private
   */
  _setPersonnel(item) {
    this.setState({ personnel: [item] });
  }

  /**
   *
   * @private
   */
  _onCancelPersonnel() {
    this.setState({ personnel: null });
  }
  changeItem(active) {
    const { index, item, show } = this.props;

    this.setState({ active, editing: false });

    show(
      active.id,
      {
        includes: ["taInfo", "profile", "phones"],
      },
      () => this.setState({ loading: false })
    );
  }
  /**
   *
   * @return {XML}
   */
  render() {
    const { personnel, active, loading } = this.state;
    const { can } = this.props;
    console.log("personnel[0]", personnel[0]);
    return (
      <Row
        style={{
          overflowY: "auto",
          height: "100%",
          margin: 0,
        }}
      >
        <Col
          sm={24}
          md={8}
          style={{
            overflowY: "auto",
            height: "100%",
          }}
        >
          <List
            onClick={(active) => this.changeItem(active)}
            // onView={(active) =>
            //   this.setState({ active, editing: false })
            // }
            // onEdit={(active) =>
            //   app.can("User@update") &&
            //   this.setState({ active, editing: true })
            // }
            // onAdd={() => this.setState({ active: null, editing: true })}
          />
        </Col>
        {/* {personnel.length !== 0 && (
          <Col
            sm={24}
            md={8}
            style={{
              overflowY: "auto",
              height: "100%",
            }}
          >
            // <Assignment
            //   onCancel={this._onCancelPersonnel}
            //   assigner={personnel[0]}
            //   component={"user"}
            // />
            <Setting user={personnel[0]} />
          </Col>
        )} */}

        {active && (
          <Tabs
            style={{
              height: "100%",
            }}
          >
            <Tabs.TabPane tab={app.translate("تنظیمات حضور و غیاب")} key="1">
              <Col md={24} style={{ height: "100%" }}>
                <SettingWrapper item={active} />
              </Col>
            </Tabs.TabPane>
            <Tabs.TabPane
              // disabled={!app.can("User@index")}
              tab={app.translate("تنظیمات پیامک")}
              key="2"
            >
              <Col md={24} style={{ height: "100%" }}>
                <Sms item={active} />
              </Col>
            </Tabs.TabPane>
          </Tabs>
        )}
      </Row>
    );
  }
}
